export default __webpack_public_path__ + "static/media/16 - Granada.9c31e15e.JPG";